import React, {useEffect} from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import {EMPTY_NOTIFICATION} from "../store/action";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
}));

const ToasterNotificationPanel = ({alert, dispatch}) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (alert) {
            setOpen(true)
        }
    }, [setOpen, alert])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
        dispatch({type: EMPTY_NOTIFICATION})
    };
    return <div className={classes.root}>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={alert?.type}>
                    {alert?.text}
                </Alert>
        </Snackbar>
    </div>
}
const mapStateToProps = state => ({
    alert: state.general?.alert
})
export default connect(mapStateToProps)(ToasterNotificationPanel);